module.exports = __webpack_public_path__ + "static/media/loader.880ebb84.gif";